import Select from 'react-select/dist/declarations/src/Select'
import { Salary_Brackets } from 'generated/apolloComponents'
import useTranslation from 'next-translate/useTranslation'
import RemoveButton from '../atoms/RemoveButton'
import { ActionType, SelectType } from '@/context/jobListContext'

const FiltersList = ({ state, dispatch }: any) => {
  const { t } = useTranslation('common')

  const handleRemoveFilter = (e: any) => {
    const tempFilters: any = { ...state.filters }
    const removedValue: any = e.target.dataset.filterValue
    const removedKey: any = e.target.dataset.filterName

    // eslint-disable-next-line default-case
    switch (removedKey) {
      case 'company':
        tempFilters[removedKey] = ''
        break
      case 'city':
      case 'skills':
      case 'role':
        ;(tempFilters[removedKey] as SelectType[]) = (
          tempFilters[removedKey] as SelectType[]
        ).filter((value: any) => value.value != removedValue)
        break
      case 'withSalary':
      case 'topTech':
      case 'salaryBrackets':
      case 'ukraineRelocation':
        delete tempFilters[removedKey]
        break
      case 'experienceLevel':
      case 'employmentType':
        tempFilters[removedKey] = (tempFilters[removedKey] as string[]).filter(
          (value: any) => value !== removedValue
        )
    }

    dispatch({
      type: ActionType.SetState,
      payload: { ...state, filters: tempFilters, page: 1 },
    })
  }

  return (
    <div className='flex flex-wrap'>
      {state.filters &&
        Object.entries(state.filters).map(([key, value]) => {
          if (value) {
            if (
              key === 'city' ||
              key === 'skills' ||
              key === 'role' ||
              key === 'experienceLevel' ||
              key === 'employmentType'
            ) {
              return (value as Select[] | string[]).map(
                (filter: any, index: number) => {
                  const valueLabel = filter.hasOwnProperty('label')
                    ? filter.label
                    : filter
                  const translationKey = `search:${valueLabel}`
                  const translatedLabel = t(translationKey)
                  const label =
                    translatedLabel === translationKey
                      ? valueLabel
                      : translatedLabel
                  return (
                    <RemoveButton
                      key={index}
                      filterKey={key}
                      filterValue={
                        filter.hasOwnProperty('value') ? filter.value : filter
                      }
                      label={label}
                      handleRemoveFilter={handleRemoveFilter}
                    />
                  )
                }
              )
            }

            if (key === 'topTech') {
              return (
                <RemoveButton
                  key={key}
                  filterKey={key}
                  filterValue={value as boolean}
                  label={t('common:top_tech_only')}
                  handleRemoveFilter={handleRemoveFilter}
                />
              )
            }
            if (key === 'ukraineRelocation') {
              return (
                <RemoveButton
                  key={key}
                  filterKey={key}
                  filterValue={value as boolean}
                  label={t('common:ukraine')}
                  handleRemoveFilter={handleRemoveFilter}
                />
              )
            }
            if (key === 'withSalary') {
              return (
                <RemoveButton
                  key={key}
                  filterKey={key}
                  filterValue={value as boolean}
                  label={
                    key === 'withSalary' ? t('common:with_brackets') : 'TopTech'
                  }
                  handleRemoveFilter={handleRemoveFilter}
                />
              )
            }

            if (key === 'salaryBrackets') {
              return (
                <RemoveButton
                  key={key}
                  filterKey={key}
                  filterValue
                  label={`${(value as Salary_Brackets).min} - ${
                    (value as Salary_Brackets).max
                  } PLN`}
                  handleRemoveFilter={handleRemoveFilter}
                />
              )
            }

            if (key === 'company') {
              return (
                <RemoveButton
                  key={key}
                  filterKey={key}
                  filterValue={value as string}
                  label={value as string}
                  handleRemoveFilter={handleRemoveFilter}
                />
              )
            }
          }
        })}
    </div>
  )
}

export default FiltersList
